var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7558 10.1849C30.844 10.2732 30.9042 10.3855 30.9291 10.5077C30.9541 10.63 30.9425 10.7569 30.8959 10.8726L23.4848 29.3998C23.4195 29.5629 23.3104 29.7049 23.1696 29.8101C23.0288 29.9153 22.8617 29.9795 22.6867 29.9959C22.5117 30.0122 22.3356 29.9799 22.1778 29.9026C22.02 29.8253 21.8865 29.706 21.7922 29.5577L17.7446 23.196L11.383 19.1485C11.2344 19.0543 11.1147 18.9208 11.0372 18.7628C10.9596 18.6048 10.9272 18.4285 10.9436 18.2532C10.9599 18.078 11.0243 17.9107 11.1297 17.7698C11.2352 17.6289 11.3774 17.5198 11.5409 17.4546L30.068 10.0461C30.1838 9.99947 30.3107 9.98791 30.433 10.0128C30.5552 10.0377 30.6675 10.098 30.7558 10.1862V10.1849ZM19.0157 22.8241L22.5321 28.349L28.5601 13.2798L19.0157 22.8241ZM27.6597 12.3793L12.5904 18.4073L18.1165 21.9224L27.6597 12.3793Z",
    fill: "#146C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.59521772287fbeba197edb49f0ae64fc.svg";
export { ForwardRef as ReactComponent };